import React from 'react';
import { Button } from 'react-bootstrap';

export function HHIELinkBtn(props) {
    return (
        <>
            <Button 
                style={{
                    color: 'DodgerBlue',
                    border: 'none',
                    background: 'none',
                    textDecoration: 'underline'
                }}
                // onMouseEnter={() => setIsHover(true)}
                // onMouseLeave={() => setIsHover(false)}
                onMouseEnter={(e) => { e.target.style.color = 'blue' }}
                onMouseLeave={(e) => { e.target.style.color = 'DodgerBlue' }}
                onClick={(props.onClick) ? props.onClick : () => { alert("Function not implemented yet, please pass in an onclick function."); }}
                disabled={props.disabled}
            >
                {props.name}
            </Button>
        </>
    )
}
